import type { QueryClient } from '@tanstack/react-query';

import { getClusterQueryKey } from '@cast/shared-cluster-context-data-access';
import { CLUSTER_OVERVIEW_QUERY_KEY } from '@cast/shared-cost-data-access';

const CLUSTER_DASHBOARD_QUERY_ROOTS = [CLUSTER_OVERVIEW_QUERY_KEY] as const;

const CLUSTER_OPTIMIZATIONS_QUERY_KEY = 'cluster-optimizations';

const matchesClusterDashboardQuery = (
  queryKey: readonly unknown[],
  clusterId: string
) =>
  CLUSTER_DASHBOARD_QUERY_ROOTS.includes(
    queryKey[0] as (typeof CLUSTER_DASHBOARD_QUERY_ROOTS)[number]
  ) && queryKey.includes(clusterId);

const matchesClusterOptimizationsQuery = (
  queryKey: readonly unknown[],
  clusterId: string
) =>
  queryKey[0] === CLUSTER_OPTIMIZATIONS_QUERY_KEY &&
  Array.isArray(queryKey[2]) &&
  queryKey[2].includes(clusterId);

export const invalidateClusterDashboardQueries = (
  queryClient: QueryClient,
  clusterId: string
) =>
  Promise.all([
    queryClient.refetchQueries({
      queryKey: getClusterQueryKey({ id: clusterId }),
    }),
    queryClient.refetchQueries({
      predicate: ({ queryKey }) =>
        Array.isArray(queryKey) &&
        matchesClusterDashboardQuery(queryKey, clusterId),
    }),
    queryClient.refetchQueries({
      predicate: ({ queryKey }) =>
        Array.isArray(queryKey) &&
        matchesClusterOptimizationsQuery(queryKey, clusterId),
    }),
  ]);
